/**
 * Copyright (C) 2017 Trend Micro Inc. All rights reserved.
 */
import { combineReducers } from 'redux';
import bannerFeed from './banner-feed';
import sidePanelFeed from './side-panel-feed';
import softwareFeed from './software-feed';

export default combineReducers({
  bannerFeed,
  sidePanelFeed,
  softwareFeed,
});
